<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="会议类型：">
            <el-input v-model="query.name" placeholder="请输入会议类型" clearable size="small" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,1)">批量启用</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,2)">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">添加会议</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" label="编号" width="50" />
        <el-table-column label="会议类型" prop="name" align="center" />
        <el-table-column label="页面排序 " prop="orderNo" align="center" />
        <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.isEnable" :active-value="true" :inactive-value="false" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="operatedName" align="center" />
        <el-table-column label="操作" align="center" width="230">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <!-- <el-button type="text" @click="handleLog(row)">日志记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <classify-add ref="classifyAdd" @created="doQueryList({})" :menuOptions="JSON.parse(JSON.stringify(list))" />
  </div>
</template>

<script>
import classifyAdd from './add'
import meetingCategoryApi from '@/api/meeting/meetingCategory'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    classifyAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        orderNoSortSign: 1
      },
      selectItems: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return meetingCategoryApi.fetchList(this.query)
        .then(({ data }) => {
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => meetingCategoryApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择分类')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => meetingCategoryApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择分类')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      meetingCategoryApi.batchState({ ids: ids, isEnable: type }).then(() => {
        this.$common.showMsg('success', '操作成功')
        return this.doQueryList({ pageNo: 1 })
      })
    },
    changeSwitch(row) {
      meetingCategoryApi.batchState({ ids: [row.id], isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.classifyAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.classifyShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.classifyAdd.handleUpdate(row)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=3&id=" + row.id);
    }
  }
}
</script>
